import { Component, OnInit } from '@angular/core';
// import { CompartilhadoService } from '../../../services/compartilhado/compartilhado.service';
import { Router } from '@angular/router';
import { CompartilhadoService } from '../../../../app/services/compartilhado/compartilhado.service';
import { CompartilhadoUsuarioService } from '../../../../app/services/compartilhado/compartilhado-usuario.service';
import { ModalConfirmacao } from '../../../../app/models/modal.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public nome: string
  public primeiroNome: string
  public email: string
  public iniciais: string
  public tipoConfirmacao: number;
  public opts: ModalConfirmacao = new ModalConfirmacao();



  constructor(
    private router: Router,
     public compartilhadoUsuarioService: CompartilhadoUsuarioService,
     public compartilhadoService: CompartilhadoService
  ) {  }

  ngOnInit() {
    let usuarioLogado = this.compartilhadoUsuarioService.obterUsuarioLogado();
    this.nome = usuarioLogado.nome;
    this.email = usuarioLogado.email;
    this.primeiroNome = this.nome.split(' ')[0];
    this.iniciais = this.obterIniciais(this.nome); 
  }

  private obterIniciais(nome: string): string {
    const partes = (nome || '').trim().split(/\s+/).filter(Boolean);

    if (!partes.length) {
      return '';
    }

    if (partes.length === 1) {
      return partes[0].substring(0, 2).toUpperCase();
    }

    return `${partes[0].charAt(0)}${partes[partes.length - 1].charAt(0)}`.toUpperCase();
  }

  signOut(): void {
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  public abrirModalLogout() {
    this.tipoConfirmacao = 1;

    this.opts = new ModalConfirmacao(
      'Deslogar do portal',
      'Tem certeza de que deseja sair do portal?',
      '',
      'Sim',
      'Não',
      1,
      true
    );
  }

  public confimarDialogo() {
    this.opts.aberto = false;

    if (this.tipoConfirmacao === 1){
      this.signOut();
    }
  }
}
